import { AgGridTable, AgGridTableRef } from '@shared/components/ui/AgGridTable';
import type { CustomColDef } from '@shared/components/ui/AgGridTable';
import { useCallback, useEffect, useRef } from 'react';
import type { Withdrawal } from '../../models';

interface WithdrawalsAgGridTableProps {
  withdrawals: Withdrawal[];
  columnDefs: CustomColDef[];
  fetchNextPage?: () => void;
  hasNextPage?: boolean;
  isFetchingNextPage?: boolean;
  enableSelection?: boolean;
  selectedWithdrawals?: Set<number>;
  onSelectionChanged?: (selectedIds: Set<number>) => void;
}

// Patrón de otras tablas (altura fija + scroll infinito + selección opcional)
export const WithdrawalsAgGridTable = ({
  withdrawals,
  columnDefs,
  fetchNextPage,
  hasNextPage = false,
  isFetchingNextPage = false,
  enableSelection = false,
  selectedWithdrawals,
  onSelectionChanged,
}: WithdrawalsAgGridTableProps) => {
  const agGridRef = useRef<AgGridTableRef>(null);

  const clearSelectionUI = useCallback(() => {
    agGridRef.current?.deselectAll();
  }, []);

  const handleSelectionChanged = useCallback(
    (selectedRows: Withdrawal[]) => {
      const selectedIds = new Set(selectedRows.map((w) => w.id));
      onSelectionChanged?.(selectedIds);
    },
    [onSelectionChanged],
  );

  useEffect(() => {
    if (selectedWithdrawals && selectedWithdrawals.size === 0) {
      clearSelectionUI();
    }
  }, [selectedWithdrawals, clearSelectionUI]);

  return (
    <AgGridTable
      ref={agGridRef}
      data={withdrawals}
      columnDefs={columnDefs}
      height="calc(100vh - 150px)"
      rowHeight={64}
      enableSelection={enableSelection}
      suppressAggFuncInHeader={true}
      onSelectionChanged={enableSelection ? handleSelectionChanged : undefined}
      fetchNextPage={fetchNextPage}
      hasNextPage={hasNextPage}
      isFetchingNextPage={isFetchingNextPage}
    />
  );
};
